import { Axios } from './api';

export const recoveryPassword = (email) => Axios.post('/auth/recovery', {
  email,
}).then(({ data }) => data);
